import { render, staticRenderFns } from "./VuesticTreeCategory.vue?vue&type=template&id=9fcdfa5c&"
import script from "./VuesticTreeCategory.vue?vue&type=script&lang=js&"
export * from "./VuesticTreeCategory.vue?vue&type=script&lang=js&"
import style0 from "./VuesticTreeCategory.vue?vue&type=style&index=0&id=9fcdfa5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports